var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    "aria-labelledby": titleId,
    width: "18px",
    height: "16px",
    viewBox: "0 0 18 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "pictureUploadedTitle"
  }, "Picture uploaded") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "pictureUploadedTitle"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-315.000000, -1184.000000)",
    fill: "#4B7BFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(226.000000, 1136.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107,48.9991779 L107,62.9991779 C107,63.9543691 106.877531,63.9971688 106.124255,63.9990608 L90,63.9991467 C89.1356994,63.9991467 89,64.0046424 89,62.9991779 L89,48.9991779 C89,48.0942598 89.1099165,48.008169 89.7619749,48 L106.238025,48 C106.890084,48.008169 107,48.0942598 107,48.9991779 Z M94.6390977,54.2702776 L90,59.228 L90,62.9991779 L102.673,62.999 L94.6390977,54.2702776 Z M103.508621,58.2405994 L101.566,60.322 L104,62.9991779 L106,62.9991779 L106,60.837 L103.508621,58.2405994 Z M106,48.9991779 L90,48.9991779 L90,57.676 L94.6390977,52.7050602 L100.729,59.402 L103.508621,56.4697661 L106,58.989 L106,48.9991779 Z M100.75,50.8227073 C101.840909,50.8227073 102.75,51.7317982 102.75,52.8227073 C102.75,53.9136164 101.840909,54.8227073 100.75,54.8227073 C99.6227273,54.8227073 98.75,53.9136164 98.75,52.8227073 C98.75,51.7317982 99.6590909,50.8227073 100.75,50.8227073 Z M100.75,51.7317982 C100.168182,51.7317982 99.6954545,52.2045255 99.6954545,52.7863437 C99.6954545,53.3681618 100.168182,53.8408891 100.75,53.8408891 C101.331818,53.8408891 101.804545,53.3681618 101.804545,52.7863437 C101.804545,52.2045255 101.331818,51.7317982 100.75,51.7317982 Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImage);
export default __webpack_public_path__ + "static/media/icon-image.f42eef17dec2e32e61333071653009e3.svg";
export { ForwardRef as ReactComponent };